import { createStore } from '@calvear/react-redux';
import { SamplePartition, SampleReducer, SampleSaga } from './sample';
import { UserPartition, UserReducer } from './user';
import { NotificationPartition, NotificationReducer } from './notification';

const debug = process.env.REACT_APP_DEBUG === 'true';

const reducers = {
    [SamplePartition.Key]: SampleReducer,
    [UserPartition.Key]: UserReducer,
    [NotificationPartition.Key]: NotificationReducer,
};

const sagas = [SampleSaga()];

export default createStore({ reducers, sagas, debug });
